"use client";

import { useTranslations } from 'next-intl';
import { useEffect, useState } from "react";
import Button from '../Button/Button';
import Slider from '../Slider/Slider';
import VideoGrid from '../VideoGrid/VideoGrid';


function Videos() {
  const t = useTranslations('home.videos');
  const [isMobile, setIsMobile] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);



  // Get video data from translations
  // t.raw returns objects with numeric keys, convert to array
  const slides = [
    {
      id: 1,
      videoUrl: "/videos/Taylor_n.mp4",
      text: t.raw('slides.1.text'),
      title: t('slides.1.title'),
      font: 12
    },
    {
      id: 2,
      videoUrl: "/videos/video2_n.mp4",
      text: t.raw('slides.2.text'),
      title: t('slides.2.title'),
      font: 14
    },
    {
      id: 3,
      videoUrl: "/videos/Olivia_n.mp4",
      text: t.raw('slides.3.text'),
      title: t('slides.3.title'),
      font: 14
    },
    {
      id: 4,
      videoUrl: "/videos/video4_n.mp4",
      text: t.raw('slides.4.text'),
      title: t('slides.4.title'),
      font: 14
    }
  ];
  const video = {
    title: t('title'),
    button: t('button'),
    slides: slides ? Object.values(slides) : []
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setActiveIndex(0);
    }
  }, [isMobile, video]);

  return video?.slides?.length ? (
    <>
      <div className='bg-pink section-py relative'>
        <div className="max-w-[1260px] mx-auto px-4 md:px-0">
          <h2 className="text-title text-center">{video.title}</h2>
          <div className="h-auto">
            <div className="relative mx-auto w-full md:max-w-[870px]" id="videos">
              {isMobile ? (
                <Slider
                  type='video'
                  slides={video.slides}
                  breakpoints={{
                    0: { slidesPerView: 1.3, spaceBetween: 10 },


                    485: { slidesPerView: 1.6, spaceBetween: 10 },
                    700: { slidesPerView: 1.9, spaceBetween: 20 },

                    900: { slidesPerView: 4, spaceBetween: 20 },
                  }}
                  imageSizes={{ width: 186, height: 340 }}
                  imageClasses={"rounded-lg"}
                  onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                  initialSlide={0}
                />
              ) : (
                <VideoGrid videos={Array.isArray(video.slides) ? video.slides.slice(0, 4) : []} />
              )}
            </div>
          </div>
          <div className="hidden md:block">
            <Button text={video.button} />
          </div>
        </div>
      </div>
    </>
  ) : null;
}

export default Videos;
